<script>
    import {getContext, tick} from 'svelte';
    import {ImageCrop} from "@novacbn/svelte-image-crop";
    import Service from "./utils/Service";

    export let model_root;
    export let application_root;
    export let currentMenuItemData;
    export let footer;

    const {close} = getContext('simple-modal');

    const service = new Service(model_root);

    let previousHeaderImageID = null;

    const maxMenuNameLength = 28;

    $ : moduleName = currentMenuItemData.mname;
    $ : menuType = currentMenuItemData.mtype || "TYPE_DEFAULT";
    $ : menuNameLength = moduleName.length;
    $ : menu_types_promise = fetchCustomMenuTypes();

    let errorMsg = "";
    let successMsg = "";

    let showAdvancedSettings = false;

    const fetchCustomMenuTypes = () => {
        return fetch(model_root + 'admin/menu/get_custom_menu_types.php', {
            method: "GET"
        })
            .then(response => response.json())
    }

    function uploadNewMenuItem() {
        const data = new FormData();
        data.append("mname", moduleName);
        data.append("mtype", menuType);
        if (footer == 1) {
            data.append("footer", 1);
        } else {
            data.append("footer", 0);
        }
        if (currentMenuItemData.mparent !== undefined) {
            data.append("mparent", currentMenuItemData.mparent);
        }

        fetch(model_root + 'admin/menu/add_menu_item.php', {
            method: "POST",
            body: data
        })
            .then(response => response.text())
            .then(msg => {
                if (msg === "success") {
                    showSuccessMsg("Menüpunkt wurde erfolgreich erstellt! Das Fenster schließt sich automatisch.");
                } else {
                    showErrorMsg(msg);
                }
            });

    }

    function updateMenuItem() {
        const data = new FormData();
        data.append("mid", currentMenuItemData.mid);
        data.append("mname", moduleName);

        fetch(model_root + 'admin/menu/update_menu_item.php', {
            method: "POST",
            body: data
        })
            .then(response => response.text())
            .then(msg => {
                if (msg === "success") {
                    showSuccessMsg("Menüpunkt wurde erfolgreich aktualisiert! Das Fenster schließt sich automatisch.");
                } else {
                    showErrorMsg(msg);
                }
            });

    }

    function hideMenuTool() {
        close();
    }

    function showSuccessMsg(msg) {
        errorMsg = "";
        successMsg = msg;
        setTimeout(hideMenuTool, 3200);
    }

    function showErrorMsg(msg) {
        errorMsg = msg;
    }

    // put later into subcomponent
    let headerImageFileInput;
    let locallySelectedHeaderImage;
    let locallySelectedHeaderImage_Name;

    const onHeaderImageSelected = (e) => {
        let image = e.target.files[0];
        locallySelectedHeaderImage_Name = image.name;
        let reader = new FileReader();
        reader.readAsDataURL(image);
        reader.onload = e => {
            locallySelectedHeaderImage = e.target.result
        };
    }

    // `image_crop` — will be our binding to the current `ImageCrop` Component instance
    let image_crop;

    const selectHeaderImage = (e) => {
        e.preventDefault();
        window.scrollTo(0, 0);
        headerImageFileInput.click();
    }

    const validateAspectRatioOfImage = (image, requiredRatio) => {
        return new Promise((resolve, reject) => {
            let htmlImg = document.createElement('img');
            htmlImg.src = URL.createObjectURL(image);
            htmlImg.onload = () => {
                console.log([htmlImg.width, htmlImg.height])
                console.log(Math.abs((htmlImg.width / htmlImg.height) - requiredRatio))
                if (Math.abs((htmlImg.width / htmlImg.height) - requiredRatio) > 0.1) {
                    reject();
                } else {
                    resolve();
                }
            }
        })
    }

    const uploadHeaderImage = async (e) => {
        e.preventDefault();

        const blob = await image_crop.get_cropped_blob();
        let compressedFile = await service.compressImage(blob);

        try {
            await validateAspectRatioOfImage(compressedFile, (3/1))

            let response = await service.uploadFile(-2, locallySelectedHeaderImage_Name, compressedFile, "header_image")

            const data = new FormData();
            data.append("mid", currentMenuItemData.mid);
            data.append("fid", response.file_id);

            fetch(model_root + 'admin/menu/update_header_image.php', {
                method: "POST",
                body: data
            })
                .then(response => response.text())
                .then(async msg => {
                    if (msg === "success") {
                        if (previousHeaderImageID !== null) {
                            await service.removeFile(previousHeaderImageID);
                        }

                        showSuccessMsg("Das Headerbild wurde erfolgreich geändert! Das Fenster schließt sich automatisch.");
                    } else {
                        showErrorMsg(msg);
                    }
                });
        } catch (e) {
            showErrorMsg("Das Bildverhältnis stimmt nicht. Bitte markieren Sie mit der Maus den Bildbereich, der verwendet werden soll.");
        }
    }

    const deleteHeaderImage = async (e) => {
        e.preventDefault();
        const data = new FormData();
        data.append("mid", currentMenuItemData.mid);
        data.append("fid", -1);

        fetch(model_root + 'admin/menu/update_header_image.php', {
            method: "POST",
            body: data
        })
            .then(response => response.text())
            .then(async msg => {
                if (msg === "success") {
                    await service.removeFile(currentMenuItemData.mheader_image);
                    showSuccessMsg("Headerbild wurde entfernt.");
                } else {
                    showErrorMsg(msg);
                }
            });
    }


    const loadHeaderImg = (currentMenuItemData.mheader_image === "INHERIT_FROM_PARENT") ? null : service.getFilePath(currentMenuItemData.mheader_image);

    const changeHeaderImg = () => {
        previousHeaderImageID = currentMenuItemData.mheader_image;
        currentMenuItemData.mheader_image = "";
        tick();
        headerImageFileInput.click();
    }

</script>

<div class="row mt-2 mb-1">
    <form
            on:submit|preventDefault={ () => {
                currentMenuItemData.mname.length === 0 ? uploadNewMenuItem() : updateMenuItem();
            } }
            on:reset|preventDefault={hideMenuTool}>

        <div class="mb-3">
            <label for="mname" class="form-label">Name des Menüpunktes:</label>
            <input
                    value={moduleName} on:input={e => moduleName = e.target.value}
                    type="text"
                    maxlength={maxMenuNameLength}
                    id="mname"
                    class:is-invalid="{menuNameLength === 0}"
                    class:is-valid="{menuNameLength > 0}"
                    class="form-control">
            <div id="emailHelp" class="form-text">Geben Sie hier den Namen des Menüpunktes an. Die Wortlänge ist
                auf {maxMenuNameLength} Zeichen begrenzt.
            </div>
        </div>


        <div class="bg-light w-100 mb-3 p-2 border header_image_upload_section">
            {#if currentMenuItemData.mheader_image === undefined}
                <p class="text-dark p-0 m-0 ms-1">Ein Headerbild kann nachträglich hinzugefügt werden.</p>
            {/if}
            {#if currentMenuItemData.mheader_image !== ""}
                {#if loadHeaderImg === null}
                {:else}
                    {#await loadHeaderImg}
                        warte..
                    {:then src}
                        <div class="change_btn float-end">
                        <button class="btn btn-secondary" on:click={changeHeaderImg}>
                            Headerbild ändern
                        </button>
                        <button class="btn btn-secondary" on:click={deleteHeaderImage}>
                            <i class="fas fa-trash"></i>
                        </button>
                        </div>
                        <img src="{application_root}files/{src}" class="header_image" />
                    {/await}
                {/if}
            {/if}
            {#if currentMenuItemData.mheader_image === "" || currentMenuItemData.mheader_image === "-1"}
                {#if locallySelectedHeaderImage === undefined}
                    {#if currentMenuItemData.mparent === null}
                        Aktuell wird als Headerbild der Systemstandard verwendet.

                    {:else}
                        Aktuell wird das Headerbild des übergeordneten Menüpunktes übernommen bzw. sofern dort keines gesetzt ist, der Systemstandard.
                    {/if}
                    <br>
                    <button class="btn btn-secondary select_empty_btn mt-1" on:click={selectHeaderImage}>
                        Headerbild auswählen
                    </button>
                {:else}
                    <ImageCrop bind:this={image_crop} src={locallySelectedHeaderImage} ratio={3/1} />
                    <br>
                    <button class="btn btn-dark upload_btn" on:click={uploadHeaderImage}>Ausschnitt hochladen und als Headerbild verwenden</button>
                    <button class="btn btn-secondary select_empty_btn" on:click={selectHeaderImage}>Anderes Bild auswählen</button>
                {/if}

            {/if}
            <input style="display:none" type="file" accept=".jpg, .jpeg, .png"
                   on:change={(e)=>onHeaderImageSelected(e)} bind:this={headerImageFileInput}>
        </div>

        <div class="mb-3">
            <div id="accordion_advanced_settings">
                <div class="card position-static">
                    <div class="card-header">
                        <h6 class="mb-0 py-1 text-muted" role="button"
                            on:click={() => { showAdvancedSettings = !showAdvancedSettings }}>
                            <i class="fas fa-sliders-h me-1"></i> Erweiterte Einstellungen
                        </h6>
                    </div>
                    <div class="collapse" class:show={showAdvancedSettings}>
                        <div class="card-body">
                            {#await menu_types_promise}
                            {:then menu_types}
                                <div class="mb-3 col-7">
                                    <label for="menu_type_select" class="form-label">Menü-Typ:</label>
                                    <select class="form-control" id="menu_type_select"
                                            disabled={currentMenuItemData.mname.length !== 0} bind:value={menuType}>
                                        <option value="TYPE_DEFAULT" selected="selected">TYPE_DEFAULT (Standard)
                                        </option>
                                        {#each menu_types as menu_type}
                                            <option value="{menu_type}">{menu_type}</option>
                                        {/each}
                                    </select>
                                    {#if currentMenuItemData.mname.length !== 0}
                                        <div class="form-text">Der Menü-Typ kann nachträglich nicht mehr geändert
                                            werden.
                                        </div>
                                    {/if}
                                </div>
                            {/await}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        {#if errorMsg.length > 0}
            <div class="alert alert-danger" role="alert">
                {errorMsg}
            </div>
        {/if}
        {#if successMsg.length > 0}
            <div class="alert alert-success" role="alert">
                <i class="fas fa-circle-notch fa-spin"></i>
                {successMsg}
            </div>
        {/if}

        {#if successMsg.length === 0}
            {#if currentMenuItemData.mname.length === 0}
                <button type="submit" class="btn btn-primary">Hinzufügen</button>
            {:else}
                <button type="submit" class="btn btn-primary">Ändern</button>
            {/if}
            <button type="reset" class="btn btn-secondary">Abbrechen</button>
        {/if}
    </form>
</div>

<style>
    .header_image {
        width: 100%;
    }

    .change_btn {
        margin-top: 12px;
        position: relative;
        margin-right: 12px;
        margin-bottom: -70px;
    }

    .header_image_upload_section .select_empty_btn {

    }


    .upload_btn {

    }
</style>
